module.exports = __webpack_public_path__ + "img/4_cover2.e184112d.png";